module.exports = __webpack_public_path__ + "img/230-singapore.05ac5a15.svg";